import * as React from "react";
import { useTranslation } from "react-i18next";

type Tone = "white" | "primary";

type Props = {
  label?: string;
  tone?: Tone;
  href?: string;
  className?: string;
  "aria-label"?: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
};

export const StackedChevrons = React.forwardRef<HTMLAnchorElement, Props>(
  function StackedChevrons(
    {
      label,
      tone = "white",
      href = "#services",
      className,
      "aria-label": ariaLabelProp,
      onClick,
    },
    ref,
  ) {
    const { t } = useTranslation('ui');
    const resolvedLabel = label ?? t('scroll');
    const ariaLabel = ariaLabelProp ?? t('scrollToNext');
    const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
      if (!onClick) return;
      e.preventDefault();
      onClick(e);
    };

    return (
      <a
        ref={ref}
        href={href}
        onClick={handleClick}
        aria-label={ariaLabel}
        className={["anchor", `tone-${tone}`, "v2", className]
          .filter(Boolean)
          .join(" ")}
      >
        <span className="v2-label">{resolvedLabel}</span>
        <span className="v2-stack" aria-hidden="true">
          <Chevron i={0} />
          <Chevron i={1} />
          <Chevron i={2} />
        </span>
      </a>
    );
  },
);

function Chevron({ i }: { i: number }) {
  return (
    <svg
      className="v2-chev"
      style={{ animationDelay: `${i * 0.45}s` }}
      width="22"
      height="10"
      viewBox="0 0 22 10"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M1 1 L11 8 L21 1"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
